import { useEffect } from "react";
import { useLocation } from "react-router";
import useTokenStore from "../store/store";
import {
  isTrackablePath,
  buildPageViewPayload,
  createPageViewDeduper,
  sendPageView,
} from "../utils/pageViewTracking";

// Module-level so the dedupe window survives StrictMode unmount/remount cycles.
const shouldSendPageView = createPageViewDeduper();

// First-party page-view tracking for logged-in users. Mounted inside <Router>
// as a ScrollToTop sibling; renders nothing. No token → no request; consent is
// enforced server-side on privacySettings.analytics.
const RoutePageViewTracker = () => {
  const location = useLocation();
  const token = useTokenStore((state: any) => state.token);

  useEffect(() => {
    if (!token || !isTrackablePath(location.pathname)) return;
    if (!shouldSendPageView(token, location.pathname)) return;
    sendPageView(token, buildPageViewPayload(location.pathname));
  }, [location.pathname, token]);

  return null;
};

export default RoutePageViewTracker;
